import React from 'react';

const ImportHooray = () => (
  <div className="add-guest-group-modal upload__success">
    <i className="zolaicon zolaicon-checkmark upload-success__checkmark" />
    <h2 className="upload-success__text">Hooray! We uploaded your spreadsheet!</h2>
  </div>
);

export default ImportHooray;



// WEBPACK FOOTER //
// ./src/components/common/modals/AddGuestGroupModal/content/ImportHooray.jsx